import FullScreenModal from "./FullScreenModal";

export default FullScreenModal;